import React from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";

const ConfirmDelete = ({
  handleDeleteModal,
  handleDelete,
  saveData,
  setConfirmDelete,
}: any) => {
  const Confirm = () => {
    handleDelete();
    setConfirmDelete(false);
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Delete Categories</h4>
          <ImCancelCircle className="catCancel" onClick={handleDeleteModal} />
        </div>
        <div className="line"></div>
        <div style={{ textAlign: "center" }}>
          <h3>Confim Delete</h3>
          <p>Confirm you want to delete this product ({saveData.name})</p>
        </div>
        <div className="catModalBtn">
          <button
            className="catBtn1"
            style={{ width: "135px", background: "#ff0303" }}
            onClick={Confirm}
          >
            Delete
          </button>
          <button className="catBtn2" onClick={handleDeleteModal}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDelete;
